export const TAS20 = 
{
    Metadata:{Name:'TAS-20',maxColumn:5,numRows:20},
    Sections:
    [
        {
            Headers:[
                "",
                "Strongly Disagree",
                "Disagree",
                "Neither Agree nor Disagree",
                "Agree",
                "Strongly Agree"
            ],
            Questions:[
                {
                    Prompt:"1. I am often confused about what emotion I am feeling.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"2. It is difficult for me to find the right words for my feelings.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"3. I have physical sensations that even doctors don’t understand.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"4. I can describe my feelings easily.",
                    Responses:[
                        {Value:5,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"5. I prefer to analyze problems rather than just describe them",
                    Responses:[
                        {Value:5,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"6. When I am upset. I don’t know if I am sad, frightened, or angry.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"7. I am often puzzled by sensations in my body.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"8. I prefer to just let things happen rather than to understand why they turned out " +
                    "that way.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"9. I have feelings that I can’t quite identify.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"10. Being in touch with emotions is essential.",
                    Responses:[
                        {Value:5,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"11. I find it hard to describe how I feel about people.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"12. People tell me to describe my feelings more.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"13. I don’t know what’s going on inside me.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"14. I often don’t know why I am angry.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"15. I prefer talking to people about their daily activities rather than their feelings.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"16. I prefer to watch “light” entertainment shows rather than psychological dramas.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"17. It is difficult for me to reveal my innermost feelings, even to close friends.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
                {
                    Prompt:"18. I can feel close to someone, even in moments of silence",
                    Responses:[
                        {Value:5,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"19. I find examination of my feelings useful in solving personal problems",
                    Responses:[
                        {Value:5,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"20. I look for hidden meanings in movies or plays.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"}
                    ]
                },
            ]
        }
    ]
}